import { ManagementExchange, ManagementOperations } from "../models/GestaoOperations";
import api from "./api";

export interface OperationsFilters {
  type?: number;
  companyId?: string;
  search?: string;
  clientId?: string;
  responsible?: string;
  stageId?: string; // id da etapa ou "none"
  status?: string;
  agendaRange?: string;
  agendaConsult?: string;
  operation?: string;
  cambio?: string;
  page?: number;
  pageSize?: number;
}

export interface ExchangeFilters {
  type?: number;
  companyId?: string;
  search?: string;
  clientId?: string;
  responsible?: string;
  view?: string;
  includeClosed?: boolean;
  page?: number;
  pageSize?: number;
}

const clean = <T extends object>(params: T): Partial<T> =>
  Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
  ) as Partial<T>;

// Propagam o erro (um painel vazio e um painel que falhou parecem iguais pro usuário).
export const getOperations = async (
  filters: OperationsFilters
): Promise<ManagementOperations> => {
  const response = await api.get(`/api/management/operations`, {
    params: clean(filters),
  });
  return response.data;
};

/** Visão atual do relatório de câmbios inteira (sem paginação) em xlsx ou pdf. */
export const exportExchange = async (filters: ExchangeFilters, format: "xlsx" | "pdf") => {
  const response = await api.get(`/api/management/exchange/export`, {
    params: { ...clean(filters), format },
    responseType: "blob",
  });
  const disposition: string = response.headers["content-disposition"] ?? "";
  const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(disposition);
  const name = match ? decodeURIComponent(match[1] ?? match[2]) : `Cambios.${format}`;
  const url = URL.createObjectURL(response.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  // Revogar na hora pode cancelar o download em alguns navegadores
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const getExchange = async (
  filters: ExchangeFilters
): Promise<ManagementExchange> => {
  const response = await api.get(`/api/management/exchange`, {
    params: clean(filters),
  });
  return response.data;
};
